/**
 * Sandbox MFE eager preload.
 *
 * Downloads sandbox's JS and CSS the moment portal's own JS executes, running
 * in parallel with React rendering. By the time SandboxRenderer mounts,
 * sandbox is already downloaded or nearly so.
 *
 * HOW TO REMOVE (when retiring the MFE):
 *   1. Delete this file.
 *   2. Remove the import and call in src/index.js.
 *   3. Remove REACT_APP_MFE_ENABLED and REACT_APP_SANDBOX_URL env vars.
 */

export function preloadSandbox() {
  // Kill switch — set REACT_APP_MFE_ENABLED=false in env to disable sandbox embedding
  // if (process.env.REACT_APP_MFE_ENABLED !== "true") return;

  var SANDBOX_BASE = process.env.REACT_APP_SANDBOX_URL;
  var IS_DEV = process.env.NODE_ENV === "development";
  var JS_URL = SANDBOX_BASE && SANDBOX_BASE + (IS_DEV ? "static/js/bundle.js" : "assets/index.js");
  var CSS_URL = IS_DEV ? null : SANDBOX_BASE && SANDBOX_BASE + "assets/index.css";

  if (!JS_URL) return;

  // Set the plugin flag BEFORE the script tag is created.
  // Sandbox reads this flag the moment it parses — must be set first.
  window.__SANDBOX_IS_PLUGIN__ = true;
  window.__SANDBOX_PUBLIC_PATH__ = SANDBOX_BASE;

  // Preload CSS (skipped in dev — CRA dev server has no separate CSS file)
  if (CSS_URL && !document.querySelector('link[data-sandbox-preload="css"]')) {
    var cssPreload = document.createElement("link");
    cssPreload.rel = "preload";
    cssPreload.as = "style";
    cssPreload.href = CSS_URL;
    cssPreload.dataset.sandboxPreload = "css";
    document.head.appendChild(cssPreload);
  }

  // Load sandbox JS — async so it doesn't block portal's render
  if (!document.querySelector('script[data-sandbox-preload="js"]')) {
    var script = document.createElement("script");
    script.src = JS_URL;
    script.async = true;
    script.dataset.sandboxPreload = "js";
    script.onload = function () {
      window.__SANDBOX_SCRIPT_LOADED__ = true;
    };
    script.onerror = function () {
      console.warn("[Portal] Sandbox preload failed. SandboxRenderer will retry.");
      window.__SANDBOX_SCRIPT_FAILED__ = true;
    };
    document.body.appendChild(script);
  }
}
